import { useEffect, useRef } from 'react'

const useReplaceLinkTarget = ({
  target = '_blank',
  disable = false,
  html,
} = {}) => {

  const rootRef = useRef()

  useEffect(() => {
    const links = rootRef.current.querySelectorAll('a')
    for(let i=0; i<links.length; i++) {
      links[i].setAttribute('target', target)
      if(disable) {
        links[i].addEventListener('click', e => {
          e.preventDefault()
          return false
        })
      }
    }
  }, [html])

  return rootRef
}

export default useReplaceLinkTarget